import { render, staticRenderFns } from "./Quiz.container.vue?vue&type=template&id=74c84980&scoped=true&"
import script from "./Quiz.container.vue?vue&type=script&lang=js&"
export * from "./Quiz.container.vue?vue&type=script&lang=js&"
import style0 from "./Quiz.container.vue?vue&type=style&index=0&id=74c84980&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c84980",
  null
  
)

export default component.exports